import * as React from "react";
import { IPushNotification } from "../../model/ModelTypes";
import { ExpansionPanel, Chip } from "react-md";
import { isNullOrUndefined } from "util";
import * as moment from "moment";
import "./static/PushNotificationPanel.scss";
export interface PushNotificationPanelProps {
    notification: IPushNotification;
    userOrganisationCode: string;
    onDeleteClicked?: Function;
    isProcessed: boolean;
    columnWidths?: number[];
    focused?: boolean;
}
interface PushNotificationPanelState {
    isCollapsed: boolean;
}
class PushNotificationPanel extends React.PureComponent<PushNotificationPanelProps, PushNotificationPanelState> {
    private links: JSX.Element[];
    render() {
        return (
            <ExpansionPanel
                columnWidths={this.props.columnWidths}
                focused={this.props.focused}
                animateContent={true}
                label=""
                secondaryLabel={
                    <div className="NotificationPanelHeaderContainer">
                        <div className="NotificationPanelHeaderTitle">
                        <p className='NotificationHeaderTitle'>{this.props.notification.title}</p>
                        {
                            !isNullOrUndefined(this.props.notification.body) &&
                            <p className="mobileRemovable" >{this.props.notification.body}</p>
                        }
                        </div>
                        <div className="NotificationPanelHeaderTime">
                        <p className="NotificationPanelHeaderTimeTitle mobileRemovable">
                        {this.props.isProcessed ? "Processed at:" : "Sending at:"}
                        </p>
                        <p>
                        {
                            this.props.isProcessed ? moment(this.props.notification.processed_time)
                                .format("DD/MMM/YYYY HH:mm:ss") :
                            moment(this.props.notification.sending_time).format("DD/MMM/YYYY HH:mm")
                        }
                        </p>
                        </div>
                    </div>
                }
                cancelLabel="Dismiss"
                saveLabel="Delete"
                saveProps={
                    {
                      disabled: isNullOrUndefined(this.props.onDeleteClicked) ||
                          this.props.notification.organisation_code !== this.props.userOrganisationCode

                    }
                }
                onSave={() => this.props.onDeleteClicked(this.props.notification)}
            >
                <div className="NotificaitonPanelBody">
                    <div className="NotificaitonPanelBodyContent">
                        <h5>Sender Name</h5>
                        <p>{this.props.notification.user.name}</p>
                    </div>
                    {
                        (!isNullOrUndefined(this.props.notification.roles) &&
                        this.props.notification.roles.length > 0) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Roles</h5>
                            {
                                this.props.notification.roles.map(
                                    (role, index) => <Chip label={role} key={`role${index}`} />
                                )
                            }
                        </div>
                    }
                    {
                        (!isNullOrUndefined(this.props.notification.groups) &&
                        this.props.notification.groups.length > 0) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Groups</h5>
                            {
                                this.props.notification.groups.map(
                                    (group, index) => <Chip label={group} key={`group${index}`} />
                                )
                            }
                        </div>
                    }
                    {
                        !isNullOrUndefined(this.props.notification.title) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Notification Title</h5>
                            <p>{this.props.notification.title}</p>
                        </div>
                    }
                    {
                        !isNullOrUndefined(this.props.notification.body) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Notification Body</h5>
                            <p>{this.props.notification.body}</p>
                        </div>
                    }
                    {
                        !isNullOrUndefined(this.props.notification.payload_data) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>App URL</h5>
                            {
                                this.links = Object.keys(this.props.notification.payload_data).map(key =>
                            <p key={key}>
                                {key} : {key === "path" ? ( this.props.notification.payload_data[key] === "" ? "home" :
                                this.props.notification.payload_data[key].split("://")[1] ) :
                                this.props.notification.payload_data[key]}
                            </p>)
                            }
                        </div>
                    }
                    {
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Time Created</h5>
                            <p>{moment(this.props.notification.created_time).format("DD/MMM/YYYY HH:mm:ss")}
                            </p>
                        </div>
                    }

                </div>
            </ExpansionPanel>
        );
    }
}
export default PushNotificationPanel;


// WEBPACK FOOTER //
// ./src/component/PushNotificationPanel/PushNotificationPanel.tsx